module.exports = __webpack_public_path__ + "static/media/WARNING_PINK.403c31df.svg";